export default __webpack_public_path__ + "static/media/2.295ea8cb.svg";